<template>
  <v-row justify="end" align="center" no-gutters>

    <div class="ma-2">
      <b>Unidades</b>: {{ itemsQuantity }}
    </div>

    <div class="ma-2">
      <b>Productos</b>: {{ currencyFormat(itemsAmount) }}
    </div>

    <div class="ma-2" v-if="hasDiscount">
      <b>Descuento</b>: -{{ currencyFormat(getItemsDiscount) }}
    </div>

    <div class="ma-2" v-if="isDelivery">
      <b>Delivery</b>: {{currencyFormat(deliveryCost)}}
    </div>

    <div class="ma-2">
      <b>Total</b>:
      <template v-if="hasDiscount">
        <span class="text-decoration-line-through grey--text mr-1">{{ currencyFormat(totalAmount) }}</span>
        <b>{{currencyFormat(totalAmountWithDiscount)}}</b>
      </template>
      <template v-else>
        {{ currencyFormat(totalAmount) }}
      </template>

    </div>

    <div class="ma-2">
      <v-tooltip top>
        <template v-slot:activator="{on}">
          <div v-on="on">
            <v-btn class="primary"
                   @click="confirmOrder"
                   :disabled="!isOrderReady"
                   v-on="on"
            >
              {{ $t('common.confirm') }}
            </v-btn>
          </div>

        </template>
        {{ orderConfirmationErrorMessage.map(m => $t(m.msg)).join(" - ") }}
      </v-tooltip>

    </div>
  </v-row>
</template>

<script>
import CurrencyMixin from "@/modules/delivery/mixins/CurrencyMixin";
import {BAR} from "@/modules/delivery/constants/OrderOrigin";

export default {
  name: "BarOrderSubmit",
  mixins:[CurrencyMixin],
  computed:{
    isDelivery(){
      return this.$store.getters.orderSystem.isDelivery
    },
    deliveryCost(){
      return this.$store.getters.orderSystem.getDeliveryCost
    },
    itemsAmount(){
      return this.$store.getters.orderSystem.getItemsAmount
    },
    itemsQuantity(){
      return this.$store.getters.orderSystem.getTotalQuantity
    },
    getItemsDiscount(){
      return this.$store.getters.orderSystem.getTotalDiscount
    },
    totalAmount(){
      return this.$store.getters.orderSystem.getTotalAmount
    },
    totalAmountWithDiscount(){
      return this.$store.getters.orderSystem.getTotalAmountWithDiscount
    },
    hasDiscount(){
      return this.$store.getters.orderSystem.hasDiscount
    },
    isOrderReady(){
      return this.$store.getters.orderSystem.isOrderReady
    },
    orderConfirmationErrorMessage() {
      let messages = []

      let orderSystem = this.$store.getters.orderSystem

      if (orderSystem.getTotalQuantity == 0) {
        messages.push({msg: 'delivery.empty.items'})
      }

      //MINIMUN PRODUCTS
      if (orderSystem.order.origin != BAR && orderSystem.cartService.getItemsQuantity < orderSystem.settings.minimunQuantity) {
        messages.push({msg: 'delivery.empty.minimunQuantity', params: {quantity: orderSystem.settings.minimunQuantity}})
      }

      //MINIMUN CATEGORY PRODUCTS
      if (orderSystem.order.origin != BAR && orderSystem.cartService.isMinimumQuantityPerCategoryReached == false) {
        messages.push({msg: 'delivery.empty.minimunCategoryQuantityNotReached'})
      }

      if (!orderSystem.order.delivery.mode) {
        messages.push({msg: 'delivery.empty.deliveryMode'})
      }

      if (!orderSystem.order.delivery.timeMode || !orderSystem.order.delivery.time) {
        messages.push({msg: 'delivery.empty.time'})
      }


      if (orderSystem.order.isDelivery && !orderSystem.order.location.address) {
        messages.push({msg: 'delivery.empty.location'})
      }

      if (!orderSystem.isContactReady) {
        messages.push({msg: 'delivery.empty.contact'})
      }

      if (!orderSystem.order.payment.method) {
        messages.push({msg: 'delivery.empty.paymentMethod'})
      }

      return messages
    },
  },
  methods:{
    async confirmOrder(){
      this.$emit('confirmOrder')
    }
  }
}
</script>

<style scoped>

</style>
